
import { isResponseForGrouping, iterateOverFilters, changeDateToCurrentTimeZone, changeDateToAccountTimeZone } from './utils'
import { msToTime } from '../../../libs/msToTime'

export default {
  middlewareForRequest: ({ loadOptions, account: { timeZone } }) => {
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      if (paramKeys === 'startDate' && typeof filterValue !== 'string') {
        return ['startDate', logicalOperator, changeDateToAccountTimeZone(filterValue, timeZone)]
      }
      return [paramKeys, logicalOperator, filterValue]
    })
    return { ...loadOptions }
  },

  middlewareForResponse: ({ transcripts, timeZone }) => {
    if (isResponseForGrouping(transcripts)) return transcripts

    let newTranscripts = []
    transcripts.forEach(transcript => {
      const { endDate, startDate, messages } = transcript;
      let newTranscript = {
        ...transcript,
        endDate: !endDate ? 0 : changeDateToCurrentTimeZone(endDate, timeZone),
        startDate: changeDateToCurrentTimeZone(startDate, timeZone),
        chatDuration: msToTime(transcript.chatDuration),
      }
      if (transcript.messages) {
        newTranscript.messages = messages.map(message => ({
          ...message,
          created: changeDateToCurrentTimeZone(message.created, timeZone),
          lastEditedTime: `${changeDateToCurrentTimeZone(message.lastEditedTime, timeZone)}`,
        }))
      }
      newTranscripts.push(newTranscript)
    })
    return newTranscripts
  },
}
